// extracted by mini-css-extract-plugin
export var button = "component-module--button--6835a";
export var main = "component-module--main--42f49";
export var providerSelectionCard = "component-module--providerSelectionCard--bb984";
export var providers = "component-module--providers--aa8c1";
export var textBold = "component-module--textBold--0624a";
export var title = "component-module--title--1ff6a";
export var warningMessage = "component-module--warningMessage--314d3";